<template>
    <h2 class="modal-title">
        <slot />
    </h2>
</template>

<script>
export default {
    name: 'ModalTitle',
}
</script>

<style lang="scss" scoped>
.modal-title{
    font-size: rem(18);
    margin-bottom: 24px;
    text-transform: uppercase;
    line-height: 120%;
    letter-spacing: 0.04em;
    font-weight: 500;
}
</style>